import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { AiEmailUpdateUnsubscribePage } from "./pages/AiEmailUpdateUnsubscribePage";
import { emailUnsubscribeRoutes } from "./routes";

export const emailUnsubscribeRoute = [
  {
    path: emailUnsubscribeRoutes.aiUpdateList,
    element: <AiEmailUpdateUnsubscribePage />,
  },
  {
    path: emailUnsubscribeRoutes.aiUpdateDetails,
    element: <AiEmailUpdateUnsubscribePage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
